// Persistent virtual-background settings
const STORAGE_KEY = 'mp_bg_settings';

export const BG_IMAGES = [
  '/images/backgrounds/bg1.jpg',
  '/images/backgrounds/bg2.jpg',
  '/images/backgrounds/bg3.jpg',
  '/images/backgrounds/bg4.jpg',
  '/images/backgrounds/bg5.jpg',
  '/images/backgrounds/bg6.jpg'
];

export const BG_DEFAULTS = {
  enabled: false,
  mode: 'blur',      // 'blur' | 'image'
  selectedIndex: 0   // 0-5 when mode === 'image'
};

export function getBgSettings() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...BG_DEFAULTS };
    const parsed = JSON.parse(raw);
    return {
      ...BG_DEFAULTS,
      ...parsed
    };
  } catch (_) {
    return { ...BG_DEFAULTS };
  }
}

export function saveBgSettings(settings) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({
      ...settings
    }));
  } catch (_) {
    // storage may be unavailable in private / restricted browsers
  }
}
